import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/audit';
export function Volumes() {
  return <section className="bg-navy-950 px-4 py-14 sm:px-6 sm:py-20" data-id="element-325" data-mp="184wtal80r692">
      <div className="mx-auto w-full max-w-5xl" data-id="element-326" data-mp="1c579srtftf26">
        <SectionHeading tone="light" eyebrow="📘 What’s inside" title="The 6 Complex Rehab Case Audit™ Volumes" subtitle="Each volume focuses on one critical part of reviewing a complex rehabilitation case." data-id="element-327" data-mp="1c607l3af4u86" />

        <div className="mt-10 space-y-5" data-id="element-328" data-mp="1quwgt3o7odad">
          {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl bg-white/[0.04] ring-1 ring-white/10" data-id="element-329" data-mp="1vtg2r42t1p2q">
              <div className="flex items-start gap-4 border-b border-white/10 p-5 sm:p-7" data-id="element-330" data-mp="fdmwyg167j8j">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold-500 font-display text-lg font-bold text-navy-950 sm:h-12 sm:w-12 sm:text-xl" data-id="element-331" data-mp="kf2gu4rm3jpc">
                  {v.numeral}
                </span>
                <div className="min-w-0" data-id="element-332" data-mp="3jbg89uc6l6pt">
                  <h3 className="font-display text-xl font-bold leading-tight text-cream-50 sm:text-2xl" data-id="element-333" data-mp="218cve18emq6">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-[15px] font-semibold leading-snug text-gold-300 sm:text-base" data-id="element-334" data-mp="3t9m7g46lryqz">
                    {v.headline}
                  </p>
                  <p className="mt-2 text-[14px] leading-relaxed text-cream-100/70 sm:text-[15px]" data-id="element-335" data-mp="61sbyn5d80ey">
                    {v.description}
                  </p>
                </div>
              </div>
              <div className="p-5 sm:p-7" data-id="element-336" data-mp="fto83snw5ggj">
                <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-gold-400" data-id="element-337" data-mp="fupo8bjrkt54">
                  You’ll get
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-338" data-mp="pruaebdm0olx">
                  {v.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-339" data-mp="wval4udado35">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-340" data-mp="11s11zjwx0npm" />
                      <span className="text-[14px] leading-snug text-cream-100/85 sm:text-[15px]" data-id="element-341" data-mp="1bidhuytsbspf">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-342" data-mp="1pieutcnbqql9">
          <CTAButton label="Get all 6 audit volumes for $27" subLabel="Plus 5 bonuses and 30+ clinical audit tools" data-id="element-343" data-mp="1pi541muggfei" />
        </div>
      </div>
    </section>;
}